import ImageZoom from 'js-image-zoom'

export default (function () {
    const imageToZoom = document.querySelectorAll('[data-image-zoom]')

    if (!imageToZoom.length) return

    imageToZoom.forEach((image) => {
        new ImageZoom(image, {
            fillContainer: true,
            zoomPosition: 'original',
            
        })
    })
})